<scf-calculator-header></scf-calculator-header>
<scf-point-of-sale
  [isMG]="false"
  [isMgWithShopping]="false"
  [isBP]="false"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (establishment)="updateCombos($event)"
  (vendor)="updateCombosVendor($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
>
</scf-point-of-sale>
<scf-request-data-autos
  [establishment]="establishment"
  [vendor]="vendor"
  mode="new"
  [expirationMonth]="expirationMonth"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (sendDataFinance)="openCalculateFinance($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
>
</scf-request-data-autos>
<scf-request-finance
  [dataCallSimulation]="dataFinance"
  [isCalculator]="true"
  [changing]="changingValueClearTable"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (switchScreen)="switchScreenAlta($event)"
  (changeExpiredMonth)="setExpiredMonth($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
>
</scf-request-finance>
